import { render, staticRenderFns } from "./validation-summary.vue?vue&type=template&id=738cb868"
import script from "./validation-summary.vue?vue&type=script&lang=js"
export * from "./validation-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports